export default __webpack_public_path__ + "static/bbq-02-d577209ec06fb1d5cda5d424a5ad3fe2.jpg";